<template>
    <div class="container">
        <h1>Unauthorized Users</h1>
        <p>This section is for managing unauthorized users.</p>
        <Checkbox label="Show Processed Users" @change="setShowProcessedUsers()" :loading="loading"/>
        <ResultsTable :tableHeaders="computedTableHeaders" :results="computedUnauthorizedUsers" :key="showProcessedUsers">
            <template v-slot:CreatedDate="{item}">
                <span>
                    {{ formatDateTimeForDisplay(item.CreatedDate) }}
                </span>
            </template>
            <template v-slot:HasBeenProcessed="{item}">
                <span>
                    {{ item.HasBeenProcessed }}
                </span>
            </template>
            <template v-slot:MarkAsProcessed="{item}">
                <span v-if="item.ProcessedDate != null">
                    {{ formatDateTimeForDisplay(item.ProcessedDate) }}
                </span>
                <v-btn v-else @click="markAsProcessed(item)">Mark as processed</v-btn>
            </template>
            <template v-slot:ProcessedDate="{item}">
                <span v-if="item.ProcessedDate != null">
                    {{ formatDateTimeForDisplay(item.ProcessedDate) }}
                </span>
            </template>
        </ResultsTable>
    </div>
</template>

<script>
import { DistributionService } from '@/api/DistributionService';
import ResultsTable from '@/components/shared/ResultsTable.vue';
import { formatDateTimeForDisplay } from '@/scripts/helper';
import Checkbox from '@/components/form/Checkbox.vue';

export default {
    name: 'UnauthorizedUsers',
    components: {
        ResultsTable,
        Checkbox
    },
    data () {
        return {
            loading: true,
            showProcessedUsers: false,
            unauthorizedUsers: [],
            tableHeaders: [
                { text: "Email", value: "id", sortable: false, filterable: true },
                { text: 'User Origin', value: 'RequestOrigin', sortable: false, filterable: true },
                { text: 'Quote Requests', value: 'QuoteCount', sortable: true, filterable: false },
                { text: "Created Date", value: "CreatedDate", sortable: true, filterable: false },
                { text: "Processed", value: "HasBeenProcessed", sortable: false, filterable: false },
                { text: "Action", value: "MarkAsProcessed", sortable: false, filterable: false },
                { text: "Processed Date", value: "ProcessedDate", sortable: true, filterable: false }
            ]
        };
    },
    computed: {
        computedUnauthorizedUsers () {
            return this.unauthorizedUsers;
        },
        computedTableHeaders () {
            if (this.showProcessedUsers) {
                return this.tableHeaders.filter(header => header.value !== 'MarkAsProcessed');
            } else {
                return this.tableHeaders.filter(header => header.value !== 'ProcessedDate');
            }
        }
    },
    methods: {
        formatDateTimeForDisplay,
        async setShowProcessedUsers () {
            this.unauthorizedUsers = [];
            this.showProcessedUsers = !this.showProcessedUsers;
            await this.getUnauthorizedUsers();
        },
        async getUnauthorizedUsers () {
            this.loading = true;
            await DistributionService.getUnauthorizedUsers({ getProcessed: this.showProcessedUsers })
                .then(response => {
                    this.unauthorizedUsers = response;
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error getting unauthorized users: ', error);
                });
        },
        async markAsProcessed (unauthorizedUser) {
            this.loading = true;
            await DistributionService.markUnauthorizedUserAsProcessed({ body: unauthorizedUser })
                .then(() => {
                    this.unauthorizedUsers = this.unauthorizedUsers.filter(user => user.id !== unauthorizedUser.id);
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error marking unauthorized user as processed: ', error);
                });
        }
    },
    async mounted () {
        await this.getUnauthorizedUsers();
    }
};
</script>

<style scoped>
</style>
